
import React from 'react';
import { ResistanceDataPage } from './ResistanceDataPageComp/ResistanceDataPage.tsx';


export function DataManResistanceDataPage({ is_admin }: { is_admin: boolean }) {

    return (
        <div>
            <ResistanceDataPage is_admin={is_admin} show_export={is_admin} />
        </div>
    )

}
